import { IVideoComments } from '@ninjacart/nc-nk-core';
import {  IFeedLongVideoData } from '../api/kisaan/interface';
import { getStreamURI } from '../api/paths';
import { IVideosThreds } from '../api/streams/interface';
import { IFeedOrStreamComment } from '../interface/comment';
import { IRemoteVideoMetadata } from '../interface/videoMetadataResponse';
import { IlongVideo, IshortVideo } from '../store/interface';
import { FallBackImage } from './fallbackImage';

const FALL_BACK_IMAGE =
  'https://codyhouse.co/web/assets/img/nuggets/preview/image-clipping-effect.png';

export const transFormStreamRes = (streams: IFeedLongVideoData[] | IlongVideo[]) => {
  return streams?.map((data) => {
    return {
      username: data?.account?.username ?? data?.account?.name,
      avatar:
        data?.account?.avatar && data?.account?.avatar[0]?.path
          ? data?.account?.avatar[0]?.path
          : FallBackImage,
      display_name: data?.account?.display_name ?? data?.account?.displayName,
      name: data?.account?.display_name ?? data?.account?.displayName,
      content: data?.content ?? data?.text,
      created_at: data?.created_at ?? data?.createdAt,
      likes_count: data?.favourites_count ?? 0,
      comments_count: data?.replies_count ?? 0,
      description: data?.content ?? data?.text,
      tags: data?.tags,
      media_attachments: data?.media_attachments,
      liked: data?.favourited ?? false,
      type: 'FEED',
      url: data?.url,
      videoId: data?.card?.videoId ?? data?.id,
      id: data?.id,
      cardType: data?.cardType ?? 'long',
    };
  });
};

export const transFormToShortsItem = (data: IshortVideo): IFeedLongVideoData => {
  const item: IFeedLongVideoData = {
    avatar: data?.account?.avatar ?? FallBackImage,
    created_at: new Date(data?.created_at),
    id: data?.id,
    likes_count: data?.favourites_count,
    liked: data?.favourited,
    comments_count: data?.replies_count,
    name: data?.account?.display_name,
    type: data?.feedType ?? 'FEED',
    media_attachments: data?.media_attachments,
    tags: [],
    description: data?.content,
    url: data?.uri ?? data?.url,
    videoId: data?.id,
    thumbnail: data?.card?.image ?? '',
    cardType: 'long',
    streamingPlaylists: [],
    text: ''
  };

  return item;
};

export const transformToLongVideo = (data: IRemoteVideoMetadata, type: string) => {
  const createDate = data?.createdAt ?? new Date();
  const item: IFeedLongVideoData = {
    avatar: data?.account?.avatars?.[0]?.path ? data?.account?.avatars?.[0]?.path : FallBackImage,
    name: data?.account?.name,
    description: data?.description ?? '',
    created_at: new Date(createDate),
    likes_count: data?.likes_count ?? 0,
    comments_count: 0,
    tags: data?.tags,
    media_attachments: [],
    liked: false,
    type: type,
    url: data?.url,
    videoId: data?.id.toString(),
    id: data?.id.toString(),
    thumbnail: '',
    cardType: 'long',
    streamingPlaylists: data?.streamingPlaylists,
    text: ''
  };

  return item;
};

export const transformStreamComment = (items: IVideoComments) => {
  return items?.data.map((data) => {
    const commmentItem: IFeedOrStreamComment = {
      content: data?.text,
      likes_count: 0,
      display_name: data?.account?.displayName,
      userId: data?.account?.name.startsWith("u") ? data?.account?.name.slice(1) : data?.account?.name,
      created_at: data?.createdAt,
      id: data?.id,
      avatar:
        data?.account?.avatars?.length > 0
          ? `${getStreamURI()}${data?.account?.avatars?.[0]?.path}`
          : FALL_BACK_IMAGE,
    };
    return commmentItem;
  });
};

export const transformFeedComment = (items: IlongVideo[]): IFeedOrStreamComment[] => {
  return items?.map((data) => {
    const commmentItem: IFeedOrStreamComment = {
      content: data?.content,
      likes_count: data?.favourites_count,
      display_name: data?.account?.display_name,
      created_at: data?.created_at,
      avatar: data?.account?.avatar,
      id: data.in_reply_to_id,
    };
    return commmentItem;
  });
};

// export const transformToPlaylistItem = (item: IRemoteVideoMetadata): PlayListItem => {
//   const startPosition = item?.userHistory?.currentTime ?? 0;
//   const playlistItem: PlayListItem = {
//     itemSource: {
//       source: {
//         uri: item.streamingPlaylists[0]?.playlistUrl,
//         startPosition: startPosition * 1000
//       },
//       poster: `${getStreamURI()}${item?.thumbnailPath}`,
//       title: item?.name,
//       itemKey: item?.id.toString(),
//     },
//   };

//   return playlistItem;
// };
